import React, { Fragment, useContext, useState, useEffect } from "react";
import { ProductContext } from "./index";
import { editProduct, getAllProduct } from "./FetchApi";
import { getAllCategory } from "../categories/FetchApi";
const apiURL = process.env.REACT_APP_API_URL;

const EditProductModal = (props) => {
  const { data, dispatch } = useContext(ProductContext);

  const [categories, setCategories] = useState(null);

  const alert = (msg, type) => (
    <div className={`bg-${type}-200 py-2 px-4 w-full`}>{msg}</div>
  );

  const [editformData, setEditformdata] = useState({
    pId: "",
    pName: "",
    pDescription: "",
    pImages: null,
    pEditImages: null,
    pStatus: "",
    pCategory: [], // Changed to array for multiple categories
    pQuantity: "",
    pPrice: "",
    pOffer: "",
    error: false,
    success: false,
  });

  useEffect(() => {
    fetchCategoryData();
  }, []);

  const fetchCategoryData = async () => {
    let responseData = await getAllCategory();
    if (responseData.Categories) {
      setCategories(responseData.Categories);
    }
  };

  useEffect(() => {
    // Ensure pCategory is an array
    const categoryArray = Array.isArray(data.editProductModal.pCategory)
      ? data.editProductModal.pCategory
      : data.editProductModal.pCategory
      ? [data.editProductModal.pCategory]
      : [];
    
    console.log("Loading product for edit:", {
      originalCategory: data.editProductModal.pCategory,
      processedCategory: categoryArray
    });
      
    setEditformdata({
      pId: data.editProductModal.pId,
      pName: data.editProductModal.pName,
      pDescription: data.editProductModal.pDescription,
      pImages: data.editProductModal.pImages,
      pStatus: data.editProductModal.pStatus,
      pCategory: categoryArray,
      pQuantity: data.editProductModal.pQuantity,
      pPrice: data.editProductModal.pPrice,
      pOffer: data.editProductModal.pOffer,
    });
  }, [data.editProductModal]);

  const fetchData = async () => {
    let responseData = await getAllProduct();
    if (responseData && responseData.Products) {
      dispatch({
        type: "fetchProductsAndChangeState",
        payload: responseData.Products,
      });
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    
    console.log("Submitting edit form with data:", editformData);
    
    // Validation côté client
    if (!editformData.pCategory || editformData.pCategory.length === 0) {
      setEditformdata({ 
        ...editformData, 
        error: "Veuillez sélectionner au moins une catégorie", 
        success: false 
      });
      setTimeout(() => {
        setEditformdata({ ...editformData, error: false, success: false });
      }, 3000);
      return;
    }
    
    if (!editformData.pEditImages) {
      console.log("Image Not upload=============", editformData);
    } else {
      console.log("Image uploading");
    }
    try {
      let responseData = await editProduct(editformData);
      console.log("Edit Product Response:", responseData); // Debug log
      
      if (responseData && responseData.success) {
        fetchData();
        setEditformdata({ ...editformData, success: responseData.success, error: false });
        setTimeout(() => {
          setEditformdata({
            ...editformData,
            success: false,
            error: false,
          });
        }, 2000);
      } else if (responseData && responseData.error) {
        setEditformdata({ ...editformData, error: responseData.error, success: false });
        setTimeout(() => {
          setEditformdata({
            ...editformData,
            error: false,
            success: false,
          });
        }, 2000);
      } else {
        console.error("Unexpected response format:", responseData);
        setEditformdata({ ...editformData, error: "Une erreur est survenue", success: false });
      }
    } catch (error) {
      console.error("Edit product error:", error);
      setEditformdata({ ...editformData, error: "Erreur de connexion", success: false });
    }
  };

  return (
    <Fragment>
      {/* Black Overlay */}
      <div
        onClick={(e) =>
          dispatch({ type: "editProductModalClose", payload: false })
        }
        className={`${
          data.editProductModal.modal ? "" : "hidden"
        } fixed top-0 left-0 z-30 w-full h-full bg-black opacity-50`}
      />
      {/* End Black Overlay */}

      {/* Modal Start */}
      <div
        className={`${
          data.editProductModal.modal ? "" : "hidden"
        } fixed inset-0 flex items-center z-30 justify-center overflow-auto`}
      >
        <div className="mt-32 md:mt-0 relative bg-white w-11/12 md:w-3/6 shadow-lg flex flex-col items-center space-y-4 px-4 py-4 md:px-8">
          <div className="flex items-center justify-between w-full pt-4">
            <span className="text-left font-semibold text-2xl tracking-wider">
              Modifier les infos
            </span>
            {/* Close Modal */}
            <span
              style={{ background: "#1E344D" }}
              onClick={(e) =>
                dispatch({ type: "editProductModalClose", payload: false })
              }
              className="cursor-pointer text-gray-100 py-2 px-2 rounded-full"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </span>
          </div>
          {editformData.error ? alert(editformData.error, "red") : ""}
          {editformData.success ? alert(editformData.success, "green") : ""}
          <form className="w-full" onSubmit={(e) => submitForm(e)}>
            <div className="flex space-x-1 py-4">
              <div className="w-1/2 flex flex-col space-y-1 space-x-1">
                <label htmlFor="name">Nom *</label>
                <input
                  value={editformData.pName}
                  onChange={(e) =>
                    setEditformdata({
                      ...editformData,
                      error: false,
                      success: false,
                      pName: e.target.value,
                    })
                  }
                  className="px-4 py-2 border focus:outline-none"
                  type="text"
                />
              </div>
              <div className="w-1/2 flex flex-col space-y-1 space-x-1">
                <label htmlFor="price">Prix *</label>
                <input
                  value={editformData.pPrice}
                  onChange={(e) =>
                    setEditformdata({
                      ...editformData,
                      error: false,
                      success: false,
                      pPrice: e.target.value,
                    })
                  }
                  type="number"
                  className="px-4 py-2 border focus:outline-none"
                  id="price"
                />
              </div>
            </div>
            <div className="flex flex-col space-y-2">
              <label htmlFor="description">Description *</label>
              <textarea
                value={editformData.pDescription}
                onChange={(e) =>
                  setEditformdata({
                    ...editformData,
                    error: false,
                    success: false,
                    pDescription: e.target.value,
                  })
                }
                className="px-4 py-2 border focus:outline-none"
                name="description"
                id="description"
                cols={5}
                rows={2}
              />
            </div>
            {/* Most Important part for uploading multiple image */}
            <div className="flex flex-col mt-4">
              <label htmlFor="image">Images du produit*</label>
              {editformData.pImages ? (
                <div className="flex space-x-1">
                  <img
                    className="h-16 w-16 object-cover"
                    src={`${apiURL}/uploads/products/${editformData.pImages[0]}`}
                    alt="productImage"
                  />
                  <img
                    className="h-16 w-16 object-cover"
                    src={`${apiURL}/uploads/products/${editformData.pImages[1]}`}
                    alt="productImage"
                  />
                </div>
              ) : (
                ""
              )}
              <span className="text-gray-600 text-xs">Au minimum 1 image</span>
              <input
                onChange={(e) =>
                  setEditformdata({
                    ...editformData,
                    error: false,
                    success: false,
                    pEditImages: [...e.target.files],
                  })
                }
                type="file"
                accept=".jpg, .jpeg, .png"
                className="px-4 py-2 border focus:outline-none"
                id="image"
                multiple
              />
            </div>
            {/* Most Important part for uploading multiple image */}
            <div className="flex space-x-1 py-4">
              <div className="w-1/2 flex flex-col space-y-1">
                <label htmlFor="status">Statut *</label>
                <select
                  value={editformData.pStatus}
                  onChange={(e) =>
                    setEditformdata({
                      ...editformData,
                      error: false,
                      success: false,
                      pStatus: e.target.value,
                    })
                  }
                  name="status"
                  className="px-4 py-2 border focus:outline-none"
                  id="status"
                >
                  <option name="status" value="Active">
                    Activer
                  </option>
                  <option name="status" value="Disabled">
                    Désactiver
                  </option>
                </select>
              </div>
              <div className="w-1/2 flex flex-col space-y-1">
                <label htmlFor="quantity">Stock disponible *</label>
                <input
                  value={editformData.pQuantity}
                  onChange={(e) =>
                    setEditformdata({
                      ...editformData,
                      error: false,
                      success: false,
                      pQuantity: e.target.value,
                    })
                  }
                  type="number"
                  className="px-4 py-2 border focus:outline-none"
                  id="quantity"
                />
              </div>
            </div>
            
            {/* Categories section with checkboxes */}
            <div className="flex flex-col space-y-2 py-4">
              <label className="font-semibold">Catégories * (Sélectionnez au moins une)</label>
              {/* Debug info */}
              <div className="text-xs text-gray-500 mb-2">
                Catégories sélectionnées: {editformData.pCategory.length > 0 
                  ? editformData.pCategory.map(c => typeof c === 'object' ? c._id : c).join(', ')
                  : 'Aucune'}
              </div>
              <div className="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto border rounded p-3">
                {categories && categories.length > 0
                  ? categories.map((category) => {
                      const categoryId = category._id;
                      const isChecked = editformData.pCategory.some(cat => 
                        (typeof cat === 'object' ? cat._id : cat) === categoryId
                      );
                      
                      console.log(`Category ${category.cName} (${categoryId}):`, {
                        isChecked,
                        pCategory: editformData.pCategory
                      });
                      
                      return (
                        <div key={categoryId} className="flex items-center space-x-2">
                          <input
                            type="checkbox"
                            id={`edit-cat-${categoryId}`}
                            value={categoryId}
                            checked={isChecked}
                            onChange={(e) => {
                              const catId = e.target.value;
                              let updatedCategories = [...editformData.pCategory];
                              
                              if (e.target.checked) {
                                // Add category if checked
                                updatedCategories.push(catId);
                                console.log("Adding category:", catId, "Result:", updatedCategories);
                              } else {
                                // Remove category if unchecked
                                updatedCategories = updatedCategories.filter(
                                  (cat) => (typeof cat === 'object' ? cat._id : cat) !== catId
                                );
                                console.log("Removing category:", catId, "Result:", updatedCategories);
                              }
                              
                              setEditformdata({
                                ...editformData,
                                error: false,
                                success: false,
                                pCategory: updatedCategories,
                              });
                            }}
                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                          />
                          <label
                            htmlFor={`edit-cat-${categoryId}`}
                            className="text-sm cursor-pointer"
                          >
                            {category.cName}
                          </label>
                        </div>
                      );
                    })
                  : <p className="text-gray-500 text-sm">Aucune catégorie disponible</p>}
              </div>
            </div>
            
            <div className="flex space-x-1 py-4">
              <div className="w-1/2 flex flex-col space-y-1">
                <label htmlFor="offer">Offre (%) *</label>
                <input
                  value={editformData.pOffer}
                  onChange={(e) =>
                    setEditformdata({
                      ...editformData,
                      error: false,
                      success: false,
                      pOffer: e.target.value,
                    })
                  }
                  type="number"
                  className="px-4 py-2 border focus:outline-none"
                  id="offer"
                />
              </div>
            </div>
            <div className="flex flex-col space-y-1 w-full pb-4 md:pb-6 mt-4">
              <button
                style={{ background: "#1E344D" }}
                type="submit"
                className="rounded-full bg-gray-800 text-gray-100 text-lg font-medium py-2"
              >
                Mettre à jour
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default EditProductModal;
